// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"714bd197","453":"89e29d6f","667":"de33cfda"}[chunkId] + ".chunk.js";
};